export default {
  loading: 'Завантаження...',
  date_time_same_today: "Сьогодні",
  date_time_same_today_at: "Сьогодні в",
  date_time_same_yesterday: "Вчора",
  date_time_same_yesterday_at: "Вчора в",
  date_time_same_at: "в",
  month_1: "Січень",
  month_2: "Лютий",
  month_3: "Березень",
  month_4: "Квітень",
  month_5: "Травень",
  month_6: "Червень",
  month_7: "Липень",
  month_8: "Ceрпень",
  month_9: "Вересень",
  month_10: "Жовтень",
  month_11: "Листопад",
  month_12: "Грудень",
  mon_1: "Січ",
  mon_2: "Лют",
  mon_3: "Бер",
  mon_4: "Кві",
  mon_5: "Тра",
  mon_6: "Чер",
  mon_7: "Лип",
  mon_8: "Сер",
  mon_9: "Вер",
  mon_10: "Жов",
  mon_11: "Лис",
  mon_12: "Гру",
  online: 'Online',
  offline: 'Offline',
  edit: 'Редагувати',
  success: 'Успішно',
  error: 'Помилка',
  save: 'Зберегти',
  profile: 'Профіль',
  chats: 'Чати',
  settings: 'Налаштування',
  log_out: 'Log Out',
}
